module.exports = (value) => value === undefined || value === null;
